import React from 'react';

interface RedButtonNextProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
}

const RedButtonNext: React.FC<RedButtonNextProps> = ({
  children,
  onClick,
  disabled = false,
  loading = false,
  type = 'button',
  className = '',
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={className}
      style={{
        width: '244px',
        height: '44px',
        opacity: disabled ? 0.5 : 1,
        borderRadius: '8px',
        padding: '12px 32px',
        background: '#E60012',
        color: 'white',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontFamily: 'Noto Sans JP',
        fontSize: '14px',
        fontWeight: 500,
        boxShadow: '0px 4px 6px -4px #0000001A, 0px 10px 15px -3px #0000001A',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.background = '#CC0010';
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.background = '#E60012';
        }
      }}
    >
      {loading ? (
        <span>読み込み中...</span>
      ) : (
        children
      )}
    </button>
  );
};

export default RedButtonNext;
